// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CalculatorController from "./calculator_controller"
application.register("calculator", CalculatorController)

import CardSearchController from "./card_search_controller"
application.register("card-search", CardSearchController)

import CsvPreviewController from "./csv_preview_controller"
application.register("csv-preview", CsvPreviewController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PricePreviewController from "./price_preview_controller"
application.register("price-preview", PricePreviewController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import SparklineChartController from "./sparkline_chart_controller"
application.register("sparkline-chart", SparklineChartController)

import SpeedListController from "./speed_list_controller"
application.register("speed-list", SpeedListController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StickyCtaController from "./sticky_cta_controller"
application.register("sticky-cta", StickyCtaController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import StripePaymentController from "./stripe_payment_controller"
application.register("stripe-payment", StripePaymentController)

import EmailPopupController from "./email_popup_controller"
application.register("email-popup", EmailPopupController)

import LiveSalesController from "./live_sales_controller"
application.register("live-sales", LiveSalesController)

import BuylistSearchController from "./buylist_search_controller"
application.register("buylist-search", BuylistSearchController)

import BuylistReviewController from "./buylist_review_controller"
application.register("buylist-review", BuylistReviewController)

import IntakeController from "./intake_controller"
application.register("intake", IntakeController)

import PosRegisterController from "./pos_register_controller"
application.register("pos-register", PosRegisterController)

import CheckInController from "./check_in_controller"
application.register("check-in", CheckInController)

import ReconciliationController from "./reconciliation_controller"
application.register("reconciliation", ReconciliationController)
